/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * It is aligned with StatusResponseException
 */
export interface ErrorResponse { 
    error?: string;
    message?: string;
    path?: string;
    status?: number;
    timestamp?: Date;
}

